import React, { Component } from "react";
import DashboardBlock from "../components/dashboard-block";
import DashboardTable from "../components/dashboard-table";
import Header from "../components/header";
import db from "../firebase";
import { notify } from "react-notify-toast";
import PieChart from "../components/PieChart";
import { DatePicker, TextField } from "material-ui";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("Ubytes")),
      totalOrders: 0,
      totalSales: 0,
      averageBasketValue: 0,
      orders: [],
      ordersShown: [],
      ordersType: [],
      channelType: [],
      to: "",
      selectedDate: new Date("2014-08-18T21:11:54"),
    };
  }

  async componentWillMount() {
    if (this.state.user.role === "Superadmin") {
      let orders = await db.collection("orders").get();
      let orderList = [];
      orders.forEach((order) => {
        orderList.push(order.data());
      });
      this.setState({ orders: orderList });
      this.orderType();
      this.channelType();

      this.averageBasketValue(orderList);
    } else {
      await this.loadData();

      await this.enumerateData();
    }
  }
  dateFilter = (startDate, endDate) => {
    let orders = this.state.orders;
    let filtered = [];
    orders.forEach((order) => {});
  };
  averageBasketValue = (orders) => {
    let price = 0;
    let len = orders.length;
    orders.forEach((order) => {
      price += order.totalPrice;
    });
    this.setState({ totalSales: price, totalOrders: len });
    this.setState({ averageBasketValue: price / len });
  };
  loadData = async () => {
    if (this.state.user.role === "Branch") {
      let orders = await db
        .collection("orders")
        .where("of", "==", this.state.user.of)
        .get();
      let ordersList = [];
      orders.forEach((order) => {
        ordersList.push(order.data());
      });
      this.setState({ orders: ordersList, ordersShown: ordersList });
      this.averageBasketValue(ordersList);
    } else if (this.state.user.role === "Merchant") {
      let orders = await db
        .collection("orders")
        .where("ofMerchant", "==", this.state.user.of)
        .get();
      let ordersList = [];
      orders.forEach((order) => {
        ordersList.push(order.data());
      });
      this.setState({ orders: ordersList, ordersShown: ordersList });
      this.averageBasketValue(ordersList);
    }
  };
  async componentDidMount() {
    if (this.state.user.role === "Superadmin") {
      this.enumerateData();
      return;
    }
    await this.loadData();
    this.orderType();
    this.channelType();
    notify.show("Data Loaded", "success");
    setInterval(() => {
      this.loadData();
    }, 2000);
  }
  findOrder(branch) {
    let orders = this.state.orders;
    let count = 0;
    let res = orders.forEach((order) => {
      if (order.of === branch.branchId) {
        count++;
      }
    });
    let payload = {
      value: count,
      title: branch.branchName,
      color: "#" + (((1 << 24) * Math.random()) | 0).toString(16),
    };

    return payload;
  }
  channelType = () => {
    let orders = this.state.orders;

    let w = 0;
    let i = 0;
    let website = 0;
    let f = 0;

    orders.forEach((order) => {
      if (order.channel === "whatsapp" || order.channel === "w") {
        w++;
      }
      if (order.channel === "instagram" || order.channel === "i") {
        i++;
      }
      if (order.channel === "website" || order.channel === "web") {
        website++;
      }
      if (order.channel === "facebook" || order.channel === "f") {
        f++;
      }
    });
    let payload = [
      {
        value: w,
        title: "whatsapp",
        color: "#" + (((1 << 24) * Math.random()) | 0).toString(16),
      },
      {
        value: i,
        title: "instagram",
        color: "#" + (((1 << 24) * Math.random()) | 0).toString(16),
      },
      {
        value: website,
        title: "website",
        color: "#" + (((1 << 24) * Math.random()) | 0).toString(16),
      },
      {
        value: f,
        title: "facebook",
        color: "#" + (((1 << 24) * Math.random()) | 0).toString(16),
      },
    ];

    this.setState({ channelType: payload });
  };
  orderType = () => {
    let orders = this.state.orders;

    let dine = 0;
    let pickup = 0;
    let delivery = 0;
    orders.forEach((order) => {
      if (order.type === "dine-in") {
        dine++;
      }
      if (order.type === "pick-up") {
        pickup++;
      }
      if (order.type === "delivery") {
        delivery++;
      }
    });
    //console.log(dine, delivery, pickup, orders);
    let payload = [
      {
        value: delivery,
        title: "delivery",
        color: "#" + (((1 << 24) * Math.random()) | 0).toString(16),
      },
      {
        value: dine,
        title: "dine-in",
        color: "#" + (((1 << 24) * Math.random()) | 0).toString(16),
      },
      {
        value: pickup,
        title: "pick-up",
        color: "#" + (((1 << 24) * Math.random()) | 0).toString(16),
      },
    ];

    this.setState({ ordersType: payload });
  };
  enumerateData = async (f) => {
    let orders = this.state.orders;
    let payload = [];
    if (this.state.user.role === "Superadmin") {
      let branch = await db.collection("Branches").get();
      branch.forEach((d) => {
        let order = this.findOrder(d.data());
        payload.push(order);
      });
      this.setState({ payload: payload });
      return;
    }
    let branches = await db
      .collection("Branches")
      .where("of", "==", this.state.user.uid)
      .get();

    branches.forEach((branch) => {
      let order = this.findOrder(branch.data());
      payload.push(order);
    });

    this.setState({ payload: payload });
  };

  render() {
    return (
      <div className="dashboard-body">
        <Header page="Dashboard"></Header>
        <div className="dashboard-filter">
          <p>Filter: </p>
          <DatePicker></DatePicker>
          <p>{" to: "}</p>

          <DatePicker value={this.state.to} onChange={(e) => console.log(e)} />

          <button>Filter</button>
        </div>

        <div className="dashboard-block-row">
          <DashboardBlock
            header="Total orders"
            quantity={`${this.state.totalOrders}`}
            unit="orders completed"
          ></DashboardBlock>
          <DashboardBlock
            header="Total sales"
            quantity={`AED ${this.state.totalSales}`}
            unit="sales"
          ></DashboardBlock>
          <DashboardBlock
            header="Average basket value"
            quantity={`AED ${this.state.averageBasketValue}`}
            unit="avaergae basket value"
          ></DashboardBlock>
          <DashboardBlock
            header="Average order rating"
            quantity="N/A"
            unit="average order rating score"
          ></DashboardBlock>
        </div>
        <div className="dashboard-block-row">
          <div className="dashboard-block-col">
            <p>Orders from Branches</p>
            <PieChart data={this.state.payload}></PieChart>
          </div>
          <div className="dashboard-block-col">
            <p>Orders type</p>
            <PieChart data={this.state.ordersType}></PieChart>
          </div>
          <div className="dashboard-block-col">
            <p>Orders from Channel</p>
            <PieChart data={this.state.channelType}></PieChart>
          </div>
        </div>
        <div className="dashboard-block-row">
          <DashboardTable></DashboardTable>
          <br></br>
        </div>
        <br></br>
      </div>
    );
  }
}
